import { defineNuxtPlugin } from 'nuxt/app'

import { relativeTime } from '~/locales/vendors/dayjs/en'

export default defineNuxtPlugin(({ $dayjs }) => {
  $dayjs.updateLocale('en', {
    relativeTime,
  })
})
